<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['tradingDatas'],
    data() {
        return {
            visitClientYdata: [1, 3, 5, 7, 9, 11, 12, 11, 9, 7, 5, 3],
            orderCreateCustomerYdata: [5, 7, 9, 11, 13, 15, 16, 15, 13, 11, 9, 7],
            orderCreatMoneyYdata: [3, 5, 7, 9, 11, 13, 14, 13, 11, 9, 7, 5],
            orderPayCustomerYdata: [9, 11, 13, 15, 17, 19, 20, 19, 17, 15, 13, 11],
            orderPayMoneyYdata: [11, 13, 15, 17, 19, 21, 22, 21, 19, 17, 15, 13],
            customerpriceYdata: [7, 9, 11, 13, 15, 17, 18, 17, 15, 13, 11, 9, 9, 11, 13, 15, 17, 18, 17, 15, 13, 11, 9, 9, 11, 13, 15, 17, 18, 17, 15, 13, 11, 9],
            xdisplaydata: []
        }
    },
    watch: {
        tradingDatas(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.tradingDatas)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.visitClientYdata = Edata[0].visitClientYdata
            this.orderCreateCustomerYdata = Edata[1].orderCreateCustomerYdata
            this.orderCreatMoneyYdata = Edata[2].orderCreatMoneyYdata
            this.orderPayCustomerYdata = Edata[3].orderPayCustomerYdata
            this.orderPayMoneyYdata = Edata[4].orderPayMoneyYdata
            this.customerpriceYdata = Edata[5].customerpriceYdata
            this.xdisplaydata = Edata[5].xdisplaydata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#41CCF0', '#67C23A', '#ACDF84', '#F5CC4D', '#E6A23C'],
                title: {
                    subtext: '指标趋势',
                    left: 'left',
                    subtextStyle: {
                        color: '#606266'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['付款金额(元)', '付费用户数', '客单价(元)', '下单用户数', '下单金额', '访客数'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '付款金额(元)',
                        type: 'line',
                        data: this.orderPayMoneyYdata
                    },
                    {
                        name: '付费用户数',
                        type: 'line',
                        data: this.orderPayCustomerYdata
                    },
                    {
                        name: '客单价(元)',
                        type: 'line',
                        data: this.customerpriceYdata
                    },
                    {
                        name: '下单用户数',
                        type: 'line',
                        data: this.orderCreateCustomerYdata
                    },
                    {
                        name: '下单金额',
                        type: 'line',
                        data: this.orderCreatMoneyYdata
                    },
                    {
                        name: '访客数',
                        type: 'line',
                        data: this.visitClientYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>